/**
 * This function is used in SpecimenEcosystemServices file, specimenEcosystemServicesStatistic function to calculate CO₂ fixation or cooling by transpiration based on age and surface sealing per species
 * @param surfaceSealing query result of specimenBySlug.surfaceSealing
 * @param age calculated in specimenEcosystemServicesStatistic function
 * @param data data on co2 fixation or on cooling by transpiration provided by TUM
 * @returns if surfaceSealing is null, return null, otherwise return a number as co2FixationPerYear represent x kg CO2/year or as cooling by transpiration represents kWh per year.
 */
export const co2FixationAndCoolingByTranspirationCalc = (surfaceSealing: number, age: number, data: [][]) => {

  if (surfaceSealing >= 0) {
    const indexRange = (data: number) => {
      const modulo = data % 10;
      const rangeStart = Math.floor(data / 10) >= 9 ? 9 : Math.floor(data / 10); // maxIndex 9
      const rangeEnd = modulo
        ? rangeStart + 1 >= 9 ? 9 : rangeStart + 1
        : rangeStart; // maxIndex 9
      return { rangeStart, rangeEnd, modulo };
    };

    const { rangeStart: ageIndexRangeStart, rangeEnd: ageIndexRangeEnd, modulo: ageModulo } = indexRange(age);
    const { rangeStart: surfaceSealingIndexRangeStart,
      rangeEnd: surfaceSealingIndexRangeEnd,
      modulo: surfaceSealingModulo } = indexRange(surfaceSealing);


    const resultByStartSurfaceSealingIndex =
      data[ageIndexRangeStart][surfaceSealingIndexRangeStart] * (1 - ageModulo / 10)
      + data[ageIndexRangeEnd][surfaceSealingIndexRangeStart] * ageModulo / 10;

    const resultByEndSurfaceSealingIndex =
      data[ageIndexRangeStart][surfaceSealingIndexRangeEnd] * (1 - ageModulo / 10)
      + data[ageIndexRangeEnd][surfaceSealingIndexRangeEnd] * ageModulo / 10;

    const resultByAgeBySurfaceSealing =
      (resultByEndSurfaceSealingIndex * (1 - surfaceSealingModulo / 10)
        + resultByStartSurfaceSealingIndex * surfaceSealingModulo / 10).toFixed(1);

    return resultByAgeBySurfaceSealing;
  } else { return null; }

};
